<template>

    <div class="col-span-6">

        <div class="col-span-6 text-left">

            <div v-if="installType == 'websdk'" class="block">Paste this code snippet before the <code
                    class="text-green-500 text-sm">&lt;/body&gt;</code> tag in every page of your webapp - <docs-link
                    href="https://docs.birdie.so/birdie-docs/screen-recording/misc./web-sdk" /> </div>

            <div v-else class="block">Paste this code snippet before the <code
                    class="text-green-500 text-sm">&lt;/body&gt;</code> tag in every page of your webapp - <docs-link
                    href="https://docs.birdie.so/birdie-docs/getting-started/snippet" /> </div>

        </div>

        <div class="col-span-6 mt-5">

            <div class="flex flex-row justify-start w-full">

                <div class="relative rounded-xl overflow-hidden w-full code_background" v-clipboard:copy="snippet"
                    @click="copied">
                    <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm" language='javascript'
                        :code="snippet" />
                    <a href="#" v-clipboard:copy="snippet" @click.prevent.stop="copied"
                        class="absolute top-3 right-3 w-10 h-10 bg-gray-100 text-gray-800 flex flex-col justify-center items-center rounded-lg bg-opacity-50 transform duration-200 hover:bg-opacity-100 hover:scale-105"
                        v-tippy="{ content: 'copy in your clipboard' }">
                        <vue-feather type="clipboard" class="h-5 w-5"></vue-feather>
                    </a>
                </div>

            </div>


        </div>

        <div class="col-span-6 mt-5" v-if="!is_guest">

            <div class="flex flex-row justify-center px-4">
                <jet-button class="bg-blue-500" @click="openModal">
                    Need some help for installing? Email a teammate!
                </jet-button>
                <!-- <a id="emailLink" href="#" title="Send instructions to a teammate" data-toggle="modal" data-target="#emailTeammate">Need some help for installing? Email a teammate!</a> -->
            </div>

        </div>

        <!-- <div class="col-span-6 mt-8" v-if="is_modal">
                    <div class="flex flex-row justify-center px-4">
                        <jet-secondary-button
                            @click="$inertia.visit(route('settings.inapp'))">
                            Settings page for more details
                            <vue-feather type="arrow-right" class="w-4 h-4 ml-2" />
                        </jet-secondary-button>
                    </div>
                </div> -->

        <div class="col-span-6" v-if="installType == 'websdk'">

            <jet-section-border />

            <div class="flex flex-col justify-center px-4">

                <list-toggle>
                    <template #title>
                        What happens after {{ app_name }} is installed?
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            <p>When you install {{ app_name }}, it will display on each page where the code snippet is
                                present. However once installed, you won’t need to touch your code anymore: anyone can
                                easily turn {{ app_name }} on/off from your settings page in one click.</p>
                        </div>
                    </template>
                </list-toggle>

                <list-toggle class="mt-5">
                    <template #title>
                        How will {{ app_name }} affect my page load time?
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            <p>{{ app_name }} will initialize on your page's onload event which happens after your
                                site's content has entirely finished loading. That way, users are able to interact with
                                {{ app_name }} as soon as they hit your site.</p>
                            <p>If you have other JavaScript running, {{ app_name }} will start loading alongside the
                                rest of your site's code.</p>
                        </div>
                    </template>
                </list-toggle>

                <list-toggle class="mt-5">
                    <template #title>
                        Can I identify my users?
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            <p>Sure! When your visitors are known you can give to {{ app_name }} a few more details to
                                identify them, thus every feedback they send you will be attributed to a known
                                user.<br />You can add up to 3 (optional) contact infos, a short draw is better than a
                                long read, check the example below:</p>
                            <div
                                class="relative rounded-t-none rounded-b-xl overflow-hidden code_background -ml-5 -mr-5 -mb-5 mt-3">
                                <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm"
                                    language='javascript' :code="str_example1" />
                                <!-- <pre class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm"><code class="language-html text-blue-100 flex flex-wrap" v-html="str_example1"></code></pre> -->
                            </div>
                        </div>
                    </template>
                </list-toggle>

                <list-toggle class="mt-5">
                    <template #title>
                        How do I customize the launcher?
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            If you’d like the widget to open from a specific button, link or element in your app, you
                            can create a custom launcher. For example, you can trigger the widget to open when a
                            customer clicks on your <em>Send a feedback</em> button or Feedback icon.

                            <p>Note: You can add as many custom launchers to your app or website as you wish.</p>

                            <h6 class="text-gray-900 mt-5 text-lg">How to create a custom launcher on your web app or
                                site?</h6>

                            <p>Simply add the classname <code class="text-green-500 text-sm">zstw_open</code> to one or
                                multiple elements you want to use as a launcher, see 2 examples below:</p>

                            <div class="relative overflow-hidden code_background -ml-5 -mr-5 my-3">
                                <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm" language='html'
                                    :code="str_example2" />
                            </div>



                            <h6 class="text-gray-900 mt-5 text-lg">Handling the widget with Javascript</h6>

                            <p>In some situations you might prefer using Javascript to command the widget opening, we
                                exposed a few methods at your disposal:</p>
                            <ul class="list-disc list-inside">
                                <li class="mt-2"><span class="text-gray-900">Know the widget status:</span> <code
                                        class="text-green-500 text-sm">window.zest.widget.opened()</code> will return a
                                    <code class="text-green-500 text-sm">boolean</code>.
                                </li>
                                <li class="mt-2"><span class="text-gray-900">Open the widget:</span> <code
                                        class="text-green-500 text-sm">window.zest.widget.open()</code> will open the
                                    widget if not already opened.</li>
                                <li class="mt-2"><span class="text-gray-900">Close the widget:</span> <code
                                        class="text-green-500 text-sm">window.zest.widget.close()</code> will close the
                                    widget if not already closed.</li>
                                <li class="mt-2"><span class="text-gray-900">Toggle open/close automatically:</span>
                                    <code class="text-green-500 text-sm">window.zest.widget.toggle()</code>.
                                </li>
                            </ul>

                            <p class="mt-4">For example:</p>

                            <div
                                class="relative rounded-t-none rounded-b-xl overflow-hidden code_background -ml-5 -mr-5 -mb-5 mt-3">
                                <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm"
                                    language='javascript' :code="str_example3" />
                            </div>

                            <a name="custom-launcher"></a>

                        </div>

                    </template>

                </list-toggle>

                <list-toggle class="mt-5">
                    <template #title>
                        Do you have code samples?
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            <p>You will find <a href="https://docs.birdie.so" target="_blank" title="Knowledge Base"
                                    class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">in our knowledge
                                    base</a> some useful information into the <span class="font-bold">Setup and
                                    Tips</span> section.</p>
                        </div>
                    </template>
                </list-toggle>







            </div>


        </div>

        <modal-email-teammate v-if="!is_guest" type="inapp" ref="modalEmailTeammate"
            @confirmed="emailSent"></modal-email-teammate>

    </div>

</template>






<script>

import JetButton from '@/Jetstream/Button'
import ModalEmailTeammate from '@/Components/Modals/EmailTeammate'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import ListToggle from '@/Components/UI/ListToggle'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'

import 'highlight.js/styles/github-dark.css'
import hljsVuePlugin from "@highlightjs/vue-plugin"

export default {

    props: ["team_slug", "team_name", "snippet_original", "blur_snippet",
        "str_example1", "str_example2", "str_example3", "is_modal", "installType"],

    components: {
        JetButton, JetSectionBorder, ListToggle, JetSecondaryButton,
        ModalEmailTeammate, highlightjs: hljsVuePlugin.component
    },

    data() {
        return {
            is_guest: this.$page.props.is_guest,
            faq1: false,
            onboard_install: false,
            app_name: this.$page.props.app_name
        }
    },

    created() {
        if (!this.is_guest) {
            if (this.$page.props.user.current_team.metadata) {
                let json = JSON.parse(this.$page.props.user.current_team.metadata)
                if (json.onboard_install) {
                    this.onboard_install = json.onboard_install == "yes"
                }
            }
        }
    },
    computed: {
        // team_name() {
        //     return this.is_guest ? "" : this.$page.props.user.current_team.name
        // },
        snippet() {
            if (this.installType == 'websdk') {
                return this.str_example1
            } else {
                return this.blur_snippet
            }
        }
    },
    mounted() {

    },
    methods: {
        emailSent: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Message sent to your teammate!", options)
        },
        copied: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Code snippet copied in your clipboard!", options)
            this.set_onboarding_done()

        },
        openModal: function () {
            this.$refs.modalEmailTeammate.open()
        },
        set_onboarding_done() {
            if (this.onboard_install || this.is_guest) {
                return
            }
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            var params = {
                meta: "onboard_install",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        this.onboard_install = true
                        this.EventBus.emit('onboarding_step_validation', 'onboard_install');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

}

</script>

<style>
.code_background {
    background-color: #172938;
}

.hljs {
    background: transparent !important;
}
</style>
